import { PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when a function, method or a specific use case inst fully implemented.
 * Should rarely be used, avoid usage to reach production ready code.
 */
export class NotImplementedError extends PoolbettingError {
  constructor(message = 'Not implemented yet', options?: ErrorOptions) {
    super(message, options, 'UNKNOWN');
    this.name = 'NotImplementedError';
  }
}
